import Link from 'next/link';
import React from 'react';
import StyledLink from './StyledLink';

export type StyledNextLinkProps = {
  href: string;
  children: React.ReactNode;
};

export default function StyledNextLink({
  href,
  children,
}: StyledNextLinkProps) {
  return (
    <Link href={href} passHref>
      <StyledLink>{children}</StyledLink>
    </Link>
  );
}
